module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-bg-light-blue-inot tw-bg-cards-texture tw-rounded tw-p-3 noselect tw-relative tw-flex tw-flex-col tw-h-[350px]",
    attrs: {
      "data-cy": "cy-card-news",
      "data-testid": "newsCard-card"
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-font-light tw-text-3xl tw-text-white tw-h-8 tw-mr-auto",
    attrs: {
      "data-testid": "newsCard-title"
    }
  }, [_vm._v("\n            ACTUALITÉS\n        ")]), _vm._v(" "), _c('Button', {
    staticClass: "tw-mr-2",
    attrs: {
      "color": "teal",
      "textSmall": true,
      "text": "DSN",
      "icon": "fa-solid fa-globe",
      "title": "Voir les informations liées à la DSN",
      "data-testid": "newsCard-DSN-button"
    },
    on: {
      "click": function($event) {
        _vm.viewActualite('https://www.net-entreprises.fr/')
      }
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "tw-mr-2",
    attrs: {
      "color": "teal",
      "textSmall": true,
      "text": "Actu.",
      "icon": "fa-solid fa-globe",
      "title": "Voir toutes les actualités",
      "data-testid": "newsCard-actu-button"
    },
    on: {
      "click": function($event) {
        _vm.openAideEnLigne()
      }
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "color": "teal",
      "textSmall": true,
      "text": "UPTEO",
      "icon": "fa-solid fa-globe",
      "title": "Voir les informations liées à Upteo",
      "data-testid": "newsCard-UPTEO-button"
    },
    on: {
      "click": function($event) {
        _vm.viewActualite('https://upteo.septeo.com')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-grow tw-overflow-hidden"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "tw-h-full"
  }, [(!_vm.errorGetActu) ? _c('div', {
    staticClass: "tw-h-full"
  }, [(_vm.listeActualites.length > 0) ? _c('VerticalScroll', [_c('div', {
    staticClass: "tw-w-full tw-divide-y tw-divide-gray-200/75"
  }, _vm._l((_vm.listeActualites), function(actualite) {
    return _c('div', {
      staticClass: "tw-flex tw-items-center tw-justify-between tw-py-3",
      class: _vm.listeActualites.length > 1 ? 'first:tw-pt-0 first:tw-pb-3 last:tw-pb-0 last:tw-pt-3' : 'tw-py-0',
      attrs: {
        "data-testid": "newsCard-news"
      }
    }, [_c('div', {
      staticClass: "tw-flex tw-w-full tw-rounded tw-p-3 tw-text-white tw-transition-colors tw-duration-200 tw-cursor-pointer tw-group tw-bg-white/10 hover:tw-bg-white/25",
      on: {
        "click": function($event) {
          _vm.viewActualite(actualite.Link)
        }
      }
    }, [_c('div', {
      staticClass: "tw-w-full"
    }, [(actualite.PubDate) ? _c('div', {
      staticClass: "tw-flex tw-mb-2"
    }, [(actualite.PubDate) ? _c('div', {
      staticClass: "tw-text-xs tw-bg-white/50 tw-px-2 tw-py-1 tw-rounded tw-text-black tw-mr-2"
    }, [_c('span', {
      staticClass: "tw-font-bold"
    }, [_vm._v(_vm._s(_vm._f("moment")(actualite.PubDate, "DD/MM/YY")))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tw-uppercase tw-leading-5 tw-font-bold tw-mb-2",
      attrs: {
        "data-testid": "newsCard-news-title"
      }
    }, [_vm._v(_vm._s(actualite.Title))]), _vm._v(" "), _c('div', {
      staticClass: "tw-leading-5 ellipsis",
      domProps: {
        "innerHTML": _vm._s(actualite.Description)
      }
    })])])])
  }))]) : _c('div', {
    staticClass: "tw-full tw-flex tw-flex-col tw-justify-center tw-items-center"
  }, [_c('div', {
    staticClass: "fa-stack fa-2x tw-mb-2"
  }, [_c('span', {
    staticClass: "fa-solid fa-circle fa-stack-2x tw-text-white/10"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa-light fa-empty-set fa-stack-1x fa-inverse tw-text-white"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-white"
  }, [_vm._v("Aucune actualité")])])], 1) : _c('div', {
    staticClass: "tw-full tw-flex tw-flex-col tw-justify-center tw-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tw-text-white"
  }, [_vm._v("Erreur lors de la récupération des actualités")])])]) : _c('div', {
    staticClass: "tw-w-full tw-divide-y tw-divide-gray-200 tw-animate-pulse tw-overflow-hidden"
  }, _vm._l((3), function(n) {
    return _c('div', {
      staticClass: "tw-py-3 first:tw-pt-0 first:tw-pb-3 last:tw-pb-0 last:tw-pt-3 tw-divide-gray-200"
    }, [_c('div', {
      staticClass: "tw-bg-gray-200 tw-h-[77px] tw-w-full tw-rounded"
    })])
  }))]), _vm._v(" "), _c('modal-card-news', {
    attrs: {
      "news": _vm.listeActualites,
      "currentActu": _vm.currentActu
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fa-stack fa-2x tw-mb-2"
  }, [_c('span', {
    staticClass: "fa-solid fa-circle fa-stack-2x tw-text-white/10"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa-solid fa-exclamation fa-stack-1x fa-inverse tw-text-red-400"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65fc7370"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/cards/cardNews/cardNews.vue.html
// module id = grgf
// module chunks = 2